import { apiInstance, gql } from "@/services/httpAdapter";

export async function getStartDatePayPeriodForPayPlanAssignment(locationId) {
	const query = gql`
		query getStartDatePayPeriodForPayPlanAssignment($locationId: String!) {
			getStartDatePayPeriodForPayPlanAssignment(locationId: $locationId)
		}
	`;

	const variables = {
		locationId,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getStartDatePayPeriodForPayPlanAssignment;
	} catch (err) {
		throw new Error(err);
	}
}
